var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65442 10.125H16.6544C16.9306 10.125 17.1544 9.90116 17.1544 9.625V8.375C17.1544 8.09884 16.9306 7.875 16.6544 7.875H3.65442C3.37826 7.875 3.15442 8.09884 3.15442 8.375V9.625C3.15442 9.90116 3.37826 10.125 3.65442 10.125ZM3.65442 15.125H16.6544C16.9306 15.125 17.1544 14.9012 17.1544 14.625V13.375C17.1544 13.0988 16.9306 12.875 16.6544 12.875H3.65442C3.37826 12.875 3.15442 13.0988 3.15442 13.375V14.625C3.15442 14.9012 3.37826 15.125 3.65442 15.125ZM3.65442 20.125H16.6544C16.9306 20.125 17.1544 19.9012 17.1544 19.625V18.375C17.1544 18.0988 16.9306 17.875 16.6544 17.875H3.65442C3.37826 17.875 3.15442 18.0988 3.15442 18.375V19.625C3.15442 19.9012 3.37826 20.125 3.65442 20.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6dbcc97458bc3ac1f4d70ada393d7879.svg";
export { ForwardRef as ReactComponent };